import Cookies from 'js-cookie'

let env = process.env.NODE_ENV
// let env = 'test'

// 开发环境 环境变量改为可配置
if (env === 'development') {
  !Cookies.get('kf_env') && (Cookies.set('kf_env', 'test'))
  env = Cookies.get('kf_env')
}

const server = {
  development: {
    robotUrl: 'http://10.204.42.156:9292/solrServer',
    imUrl: 'http://10.204.42.156:9295',
    socketUrl: 'ws://10.204.42.156:9295/websocket/',
    aiServer: 'http://10.204.42.156:9295',
    imgUplpadUrl: 'https://uat.keyclass.cn/adminServer/fileUpload/imgUpload',
    SDKAppID: 1400509579
  },
  test: {
    robotUrl: 'https://test.usongshu.com/solrServer',
    imUrl: 'https://test.usongshu.com/imServer',
    aiServer: 'https://test.usongshu.com/sseServer',
    socketUrl: 'wss://test.usongshu.com/websocket/',
    imgUplpadUrl: 'https://uat.keyclass.cn/adminServer/fileUpload/imgUpload',
    SDKAppID: 1400509579
  },
  production: {
    robotUrl: `https://${location.hostname}/solrServer`,
    imUrl: `https://${location.hostname}/imServer`,
    aiServer: `https://${location.hostname}/sseServer`,
    socketUrl: `wss://${location.hostname}/websocket/`,
    imgUplpadUrl: 'https://www.keyclass.cn/adminServer/fileUpload/imgUpload',
    SDKAppID: 1400492017
  }
}

export default server[env]



// WEBPACK FOOTER //
// ./src/config/index.js